import React from 'react';
import styled from '@emotion/styled';

const text = {
  identification: '본인확인 ',
  requestVerify: '인증요청 ',
  confirmVerify: '인증완료 ',
  occupation: '회원유형 ',
  company: '회사명 ',
};

export const OptionsComponent = (props) => {
  const { values, bottomText, handleSignupChange, handleSignupSMSRequest, handleSignupVerifyCode } = props;

  return (
    <OptionContainer>
      <MobileInputTitle>{text.identification}</MobileInputTitle>
      <PhoneReqWarp>
        <InputTitle>{text.identification}</InputTitle>
        <PhoneInput
          type='tel'
          name='phoneNumber'
          placeholder='01012345678'
          onChange={handleSignupChange}
          value={values.phoneNumber}
          autoComplete='off'
          disabled={values.verifyStatus === 'success'}
        />
        <PhoneButton
          isReq={values.verifyStatus}
          onClick={handleSignupSMSRequest}
          disabled={values.phoneNumber.length > 9 && !bottomText.phoneNumber ? false : true}
        >
          {text.requestVerify}
        </PhoneButton>
      </PhoneReqWarp>
      <BottomTextWarp>
        {!values.SMSSent && <BottomWarningText>{bottomText.phoneNumber}</BottomWarningText>}
        {values.SMSSent && values.phoneStatus === 'pending' && (
          <BottomSuceessText>{bottomText.phoneNumber}</BottomSuceessText>
        )}
        {values.SMSSent && values.phoneStatus === 'exists' && (
          <BottomWarningText>{bottomText.phoneNumber}</BottomWarningText>
        )}
      </BottomTextWarp>
      <PhoneAuthWarp>
        <InputTitle />
        <PhoneInput
          type='text'
          name='verificationCode'
          placeholder='인증번호'
          autoComplete='off'
          onChange={handleSignupChange}
          value={values.verificationCode}
          disabled={values.verifyStatus === 'success'}
        />
        <PhoneButton
          isReq={values.verifyStatus}
          onClick={handleSignupVerifyCode}
          disabled={values.verifyDisabled || values.verifyStatus === 'success'}
        >
          {text.confirmVerify}
        </PhoneButton>
      </PhoneAuthWarp>
      <BottomTextWarp>
        {values.verifyStatus === 'success' && <BottomSuceessText>{bottomText.verify}</BottomSuceessText>}
        {values.verifyStatus === 'reject' && <BottomWarningText>{bottomText.verify}</BottomWarningText>}
      </BottomTextWarp>
      <MobileInputTitle>{text.occupation}</MobileInputTitle>
      <InfoWarp>
        <InputTitle>{text.occupation}</InputTitle>
        <InfoInput
          placeholder='변호사, 회계사, 노무사, 세무사, 법무사, 행정사 등'
          name='occupation'
          type='text'
          autoComplete='off'
          value={values.name}
          onChange={handleSignupChange}
        />
      </InfoWarp>
      <MobileInputTitle>{text.company}</MobileInputTitle>
      <InfoWarp>
        <InputTitle>{text.company}</InputTitle>
        <InfoInput
          placeholder='회사명'
          name='company'
          type='text'
          autoComplete='off'
          value={values.name}
          onChange={handleSignupChange}
        />
      </InfoWarp>
    </OptionContainer>
  );
};

const OptionContainer = styled.article`
  padding-bottom: 50px;
  border-bottom: 1px solid #c4c4c4;
`;

const PhoneReqWarp = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 46px;
  @media only screen and (max-width: 992px) {
    margin-top: 20px;
  }
`;

const Input = styled.input`
  height: 50px;
  padding: 0 1rem;
  background-color: #ffffff;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  ::placeholder {
    color: #c4c4c4;
  }
  :focus {
    border: 1px solid #002366;
  }
`;

const PhoneInput = styled(Input)`
  max-width: 420px;
  width: 60%;
  margin-right: 1.1rem;
  @media only screen and (max-width: 992px) {
    width: 80%;
  }
`;

const PhoneButton = styled.button`
  width: 20%;
  height: 50px;
  background-color: ${(props) => (props.isReq === 'success' ? '#eee' : '#343a40')};
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  border: none;
  :disabled {
    background-color: #eee;
  }
  @media only screen and (max-width: 992px) {
    font-size: 14px;
  }
`;

const PhoneAuthWarp = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  justify-content: flex-end;
`;

const MobileInputTitle = styled.div`
  display: none;
  @media only screen and (max-width: 992px) {
    display: block;
    margin-top: 46px;
  }
`;

const InputTitle = styled.div`
  text-align: left;
  align-self: center;
  font-size: 18px;
  width: 20%;
  @media only screen and (max-width: 992px) {
    display: none;
  }
`;

const InfoWarp = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 46px;
  @media only screen and (max-width: 992px) {
    margin-top: 20px;
  }
`;

const InfoInput = styled.input`
  height: 50px;
  width: 80%;
  padding: 0 1rem;
  background-color: #ffffff;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  ::placeholder {
    color: #c4c4c4;
  }
  :focus {
    border: 1px solid #002366;
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
`;

const BottomTextWarp = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`;

const BottomText = styled.span`
  font-size: 16px;
  width: 80%;
  color: #6f6f6f;
  text-align: left;
  @media only screen and (max-width: 992px) {
    width: 100%;
    font-size: 14px;
  }
`;

const BottomWarningText = styled(BottomText)`
  color: #dc3545;
`;

const BottomSuceessText = styled(BottomText)`
  color: #28a745;
`;

const Warning = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #dc3545;
  margin-top: 10px;
  margin-left: 20%;
  @media only screen and (max-width: 992px) {
    font-size: 14px;
  }
`;

const Success = styled(Warning)`
  color: #28a745;
`;
